export const adaEventBinds = () => {
  $('.size-chart-link').on('keydown', function(e) {
    //SIZE CHART LINK
  	var sizeChart = $(this);
  	if (e.keyCode == "13") {
  		$(sizeChart).click();
  	};
  });

  $('.rec-nav .nav-up').on('keydown', function(e) {
    //YOU MAY ALSO LIKE UP ARROWS
  	var navUp = $(this);
  	if (e.keyCode == "13") {
      if(!navUp.hasClass('disabled-arrow')) {
        $(navUp).click();
      }
  	};
  });

  $('.rec-nav .nav-down').on('keydown', function(e) {
    //YOU MAY ALSO LIKE DOWN ARROWS
  	var navDown = $(this);
  	if (e.keyCode == "13") {
      if(!navDown.hasClass('disabled-arrow')) {
        $(navDown).click();
      }
  	};
  });

};
